import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { isIOS, isAndroid } from "react-device-detect";

const translations = {
  en: {
    title: "Hello!",
    message: "To give you the best experience, what would you like to do today?",
    remember: "Remember my selection for the next 30 days",
    goToLanding: "Go to Landing Page",
    login: "Log In",
    downloadApp: "Download the App",
  },
  es: {
    title: "¡Hola!",
    message: "Para brindarte la mejor experiencia, ¿qué deseas hacer hoy?",
    remember: "Recordar mi selección durante los próximos 30 días",
    goToLanding: "Ir a la Página Principal",
    login: "Iniciar Sesión",
    downloadApp: "Descargar la App",
  },
  pt: {
    title: "Olá!",
    message: "Para proporcionar a melhor experiência, o que você deseja fazer hoje?",
    remember: "Lembrar minha escolha pelos próximos 30 dias",
    goToLanding: "Ir para a Página Inicial",
    login: "Entrar",
    downloadApp: "Baixar o Aplicativo",
  },
};

export default function MobileAccessModal({ language = "en", onClose }) {
  const [rememberChoice, setRememberChoice] = useState(true);
  const t = translations[language] || translations.en;

  const storeChoice = (choice) => {
    localStorage.setItem("ylf_mobile_choice", choice);
    if (rememberChoice) {
      const expiration = new Date();
      expiration.setDate(expiration.getDate() + 30);
      localStorage.setItem("ylf_mobile_choice_expire", expiration.toISOString());
    }
  };

  const handleGoToLanding = () => {
    storeChoice("landing");
    onClose();
  };

  const handleLogin = () => {
    storeChoice("login");
    window.location.href = "/login";
  };

  return (
    <AnimatePresence>
      <motion.div
        className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <motion.div
          className="bg-white rounded-2xl shadow-xl max-w-md w-full p-6 text-center"
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.9, opacity: 0 }}
        >
          <div className="mb-4">
            <img src="/assets/images/modal/logomodal.webp" alt="Logo" className="mx-auto " />
          </div>
          <h2 className="text-2xl font-bold mb-2">{t.title}</h2>
          <p className="text-gray-600 mb-4">{t.message}</p>

          <div className="flex flex-col gap-2">
            <button
              className="bg-blue-600 text-white py-2 px-4 rounded-xl hover:bg-blue-700"
              onClick={handleGoToLanding}
            >
              {t.goToLanding}
            </button>
            <button
              className="bg-green-600 text-white py-2 px-4 rounded-xl hover:bg-green-700"
              onClick={handleLogin}
            >
              {t.login}
            </button>

            {(isIOS || isAndroid) && (
              <a
                href={
                  isIOS
                    ? "https://apps.apple.com/app/your-ios-app-id"
                    : "https://play.google.com/store/apps/details?id=your.android.package"
                }
                target="_blank"
                rel="noopener noreferrer"
                className="underline text-sm text-blue-600 mt-2"
              >
                {t.downloadApp}
              </a>
            )}
          </div>

          <label className="flex items-center mt-4 text-sm text-gray-500">
            <input
              type="checkbox"
              checked={rememberChoice}
              onChange={(e) => setRememberChoice(e.target.checked)}
              className="mr-2"
            />
            {t.remember}
          </label>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
}
